import { useNavigate } from "@solidjs/router";
import Text from "./Text";
import styles from "./Footer.module.css";

export default function Footer() {
    const navigate = useNavigate();
    return (
        <footer class={styles.footer}>
            <div class={styles.inner}>
                <span class={styles.copy}>© {new Date().getFullYear()} Vektor</span>
                <nav class={styles.links} aria-label="Legal">
                    <a href="/security" onClick={(e) => { e.preventDefault(); navigate("/security"); }}>
                        <Text val="FOOTER_SECURITY" />
                    </a>
                    <a href="/datenschutz" onClick={(e) => { e.preventDefault(); navigate("/datenschutz"); }}>
                        <Text val="FOOTER_PRIVACY" />
                    </a>
                    <a href="/impressum" onClick={(e) => { e.preventDefault(); navigate("/impressum"); }}>
                        <Text val="FOOTER_IMPRINT" />
                    </a>
                </nav>
            </div>
        </footer>
    );
}
